import type { Availability } from "@/lib/availability";
import { cn } from "@/lib/utils";

/** Overlay: never changes the card's dimensions or displaces its content. */
export function AvailabilityRibbon({
  availability,
  className,
}: {
  availability?: Availability | null;
  className?: string;
}) {
  if (!availability?.label) return null;
  return (
    <span
      className={cn(
        "pointer-events-none absolute right-0 bottom-3 z-20 rounded-l-md px-3 py-1.5 text-[11px] font-semibold shadow-sm",
        availability.state === "sold_out"
          ? "bg-surface-elevated text-text-secondary"
          : "bg-amber-100 text-amber-950",
        className,
      )}
    >
      {availability.label}
    </span>
  );
}
